import type { FeatureConfig } from '@platform/client/features';

import { LegacyCapabilitiesGuard } from '@packages/components/capabilities/legacy-capabilities-guard';

import i18n from './locales/i18n';

export default {
  routes: [
    {
      path: 'account/configuration-rules',
      children: [
        {
          index: true,
          lazy: () =>
            import('./pages/alert-configurations/alert-configurations.page'),
        },
        {
          path: 'management',
          element: (
            <LegacyCapabilitiesGuard
              capabilities={{ canManageAlertConfig: true }}
            />
          ),
          children: [
            {
              index: true,
              lazy: () =>
                import('./pages/alert-management/alert-management.page'),
            },
            {
              path: 'request',
              lazy: () =>
                import(
                  './pages/alert-management-request/alert-management-request.page'
                ),
            },
          ],
        },
        {
          path: 'alerts/:alertId',
          lazy: () => import('./pages/alert/alert.page'),
        },
        {
          path: 'suppressions/:suppressionId',
          lazy: () => import('./pages/suppression/suppression.page'),
        },
      ],
    },
  ],
  navigation: () => ({
    orgProfile: {
      alertConfigurationRules: {
        title: i18n.t('configuration-rules:title'),
        segment: '/account/configuration-rules',
      },
    },
  }),
  whatsNew: (context) => {
    return [];
  },
} satisfies FeatureConfig;
